import { render, staticRenderFns } from "./BlockAIAvailable.vue?vue&type=template&id=06207681&scoped=true"
import script from "./BlockAIAvailable.vue?vue&type=script&lang=js"
export * from "./BlockAIAvailable.vue?vue&type=script&lang=js"
import style0 from "./BlockAIAvailable.vue?vue&type=style&index=0&id=06207681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06207681",
  null
  
)

export default component.exports